import { Radio, RadioGroup } from '@dextech-ai/dex-design-system';
import PropTypes from 'prop-types';

// The rows fill the modal and keep their own spacing and dividers.
const GROUP_SX = {
	display: 'flex',
	'& .ant-radio-group': { display: 'flex', width: '100%', gap: 0 },
};

// MyInfo Business "Select Appointment" list: one DS Radio per Corppass
// appointment, keyed and valued by the appointee's ID number.
const AppointmentRadioGroup = ({ appointments = [], selectedId = '', onSelect }) => (
	<RadioGroup orientation="column" value={selectedId} onValueChange={onSelect} sx={GROUP_SX}>
		{appointments.map((item, index) => {
			const person = item['person-reference'];
			return (
				<div className="select_appointment_header-list" key={person.idno.value}>
					<div style={{ width: '10%' }}>
						<Radio
							value={person.idno.value}
							id={`appointmentName-${index}`}
							aria-label={person['person-name'].value}
							data-testid="appointment-radio-selected"
						/>
					</div>
					<div style={{ width: '90%' }}>
						<div className="appointment-sourcesystem__radio">
							<div className="appointment-label_heading appointment-label_heading_bold">
								{person['person-name'].value}
							</div>
							<div className="appointment-label_heading">
								{person.nationality.desc}
							</div>
						</div>
						<div className="appointment-sourcesystem__radio">
							<div className="appointment-label_heading">
								{item['corppass-email']?.value || 'N/A'}
							</div>
							<div className="appointment-label_heading">
								{item['corppass-mobileno']?.value || 'N/A'}
							</div>
						</div>
						<div className="appointment-sourcesystem__radio">
							<div className="appointment-label_heading">
								{item.position.desc}
							</div>
						</div>
					</div>
				</div>
			);
		})}
	</RadioGroup>
);

AppointmentRadioGroup.propTypes = {
	appointments: PropTypes.arrayOf(PropTypes.object),
	selectedId: PropTypes.string,
	onSelect: PropTypes.func.isRequired,
};

export default AppointmentRadioGroup;
